import {$, w} from './constants';
import { trackEvent } from "./gtm.js"; 

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatNumber(number) {
	return number.toLocaleString('en-US', {
		maximumFractionDigits: 1,
		notation: 'compact',
		compactDisplay: 'short'
	})
}

var princOg = 0
var princ = 0
var add = 0
var iterations = 0

export function calc() {

	var obj = {}
	princOg = parseInt($('.graph_princ_JS').val().replace(/,/g,''),10)
	princ = parseInt($('.graph_princ_JS').val().replace(/,/g,''),10)
	add = parseInt($('.graph_add_JS').val().replace(/,/g,''),10)
	var rate = parseFloat($('.graph_rate_JS').val(),10)/100
	var years = parseInt($('.graph_slider_JS').slider('value'),10)
	var addRate = parseInt($('.graph_tag_JS.active').data('add'),10)
	var months = years * addRate
	for (var i = 1; i <= months; i++) {
		princ += add
		princ += princ * (rate / addRate)
		if (i%addRate == 0) {
			obj['add'+(i/addRate)] = add*i
			obj['val'+(i/addRate)] = princ.toFixed(0)
		}
	}
	$('.graph_years_JS').text(years)
	$('.graph_result_JS').text(numberWithCommas(princ.toFixed(0)))

	var princGrand = princ.toLocaleString('en-US',{maximumFractionDigits:2, notation:'compact', compactDisplay:'short'})
	var princParts = princ/4
	$('.graph_y_JS').find('span:nth-child(1)').text(formatNumber(princParts*4))
	$('.graph_y_JS').find('span:nth-child(2)').text(formatNumber(princParts*3))
	$('.graph_y_JS').find('span:nth-child(3)').text(formatNumber(princParts*2))
	$('.graph_y_JS').find('span:nth-child(4)').text(formatNumber(princParts*1))

	if (iterations == 0) {
		$('.calc_graph_JS').addClass('hide-mobile').removeClass('show-mobile')
		$('.calc_controls_JS').addClass('show-mobile').removeClass('hide-mobile')
		$('.calc_JS').find('.graph_input_JS.int').val('').closest('div').removeClass('active').addClass('error')
		$('.calc_JS').find('.graph_input_JS.perc').val('')
	} else {
		$('.calc_graph_JS').addClass('show-mobile').removeClass('hide-mobile')
		$('.calc_controls_JS').addClass('hide-mobile').removeClass('show-mobile')
	}

	$('.graph_x_JS').empty()
	$('.graph_columns_JS').empty()
	$('.graph_columns_JS').attr('data-years',years)
	for (var i=1; i<=years; i++) {
		var initial = (princOg*100/princ).toFixed(2)
		var added = (obj['add'+i]*100/princ).toFixed(2)
		var vals = ((obj['val'+i]*100/princ) - initial - added).toFixed(2)
		if (years>19) {
			$('.graph_x_JS').append('<span class="thin">'+i+'</span>')
			$('.graph_columns_JS').append('<div class="calc__graph--col graph_col_JS thin"><span style="height:'+vals+'%;"></span><span style="height:'+added+'%;"></span><span style="height:'+initial+'%;"></span></div>')
		} else {
			$('.graph_x_JS').append('<span>'+i+'</span>')
			$('.graph_columns_JS').append('<div class="calc__graph--col graph_col_JS"><span style="height:'+vals+'%;"></span><span style="height:'+added+'%;"></span><span style="height:'+initial+'%;"></span></div>')
		}
	}
	var animTime = 25
	$('.graph_x_JS > span').each(function(index) {
		var span = this
		setTimeout( function(){ 
			$(span).addClass('active')
			$('.graph_col_JS:eq('+(index)+')').addClass('active')
		}, animTime);
		animTime += 25;
	})

	iterations++

}

// Toggle state of inputs when they have a value
$('.graph_input_JS.int').on('change keydown paste input', function(){
	$(this).val(this.value.match(/[0-9,]*/))
	if ($(this).val()) {
		$(this).val($(this).val().replace(/,/g,''))
		$(this).val(numberWithCommas($(this).val()))
		$(this).closest('div').addClass('active').removeClass('error')
	} else {
		$(this).closest('div').removeClass('active').addClass('error')
	}

    let eventType = "";
    if ($(this).hasClass("graph_princ_JS") && $(this).attr("data-event-money")) {
        eventType = $(this).attr("data-event-money");
    } else if ($(this).hasClass("graph_add_JS") && $(this).attr("data-event-deposit")) {
        eventType = $(this).attr("data-event-deposit");
    } else if ($(this).hasClass("graph_rate_JS") && $(this).attr("data-event-rate")) {
        eventType = $(this).attr("data-event-rate");
    }

    if (eventType) {
        trackEvent(eventType, {
            inputType: $(this).hasClass("int") ? "integer" : "percentage",
            value: $(this).val()
        });
    }
})

// Update graph columns & X axis when sliding
$('.graph_btn_JS').click(function() {
	var rate = parseFloat($('.graph_rate_JS').val(),10)
	if (rate > 0 && rate <= 15) {
		$('.graph_rate_JS').closest('.graph_input_wrap_JS').removeClass('error')
		calc()
	} else {
		$('.graph_rate_JS').closest('.graph_input_wrap_JS').addClass('error')
	}

    const eventType = $(this).attr("data-event-calculate");
    if (eventType) {
        trackEvent(eventType, {
            action: "calculate",
            montoInicial: $(".graph_princ_JS").val() || "N/A",
            inversionRecurrente: $(".graph_add_JS").val() || "N/A",
            tasa: $(".graph_rate_JS").val() || "N/A",
            anios: $(".graph_slider_JS").slider("value") || "N/A"
        });
    }
})

// Tags Toggle
$('.graph_tag_JS').click(function () {
	$('.graph_tag_JS').removeClass('active')
	$(this).addClass('active');

    const eventType = $(this).attr("data-event-monthly") || $(this).attr("data-event-yearly");
    const frequency = $(this).data("add") == 12 ? "Mensual" : "Anual";

    if (eventType) {
        trackEvent(eventType, {
            investmentType: frequency
        });
    }
})

// Reset interest rate input
$('.graph_rate_JS').on('change keydown paste input', function(){
	$(this).removeClass('error')
})


// Init Slider
if($('.graph_slider_JS').length){
	$('.graph_slider_JS').slider({
		min: 3,
		max: 30,
		step: 1,
		value: 15
	})
	
}
$('.graph_return_JS').click(function() {
	$('.calc_graph_JS').addClass('hide-mobile').removeClass('show-mobile')
	$('.calc_controls_JS').addClass('show-mobile').removeClass('hide-mobile')
})

// Display initial value
$('.graph_slider_JS').find('.ui-slider-handle').append('<span>15</span>')

// Update value of handle while sliding
$('.graph_slider_JS').on('slide', function(event,ui) {
	var years = ui.value
	$(this).find('.ui-slider-handle').find('span').text(years)
	const eventType = $(this).attr("data-event-yearly");
    if (eventType) {
        trackEvent(eventType, {
            inputType: "years",
            value: ui.value
        });
    }
})

